module.exports = __webpack_public_path__ + "img/amazon-bg.20e94a52.svg";